import { Button } from "primereact/button";
import { FunctionComponentElement, useEffect, useMemo, useState } from "react";
import Data from "./data.json";
import { Field, Types } from "./Field";
import "./avro.scss";
import { NodeInputProps } from "..";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import { v4 as uuidv4 } from "uuid";

export interface Type {
  id: string;
  name: string;
  type: any;
}

export interface TypeWithoutID {
  name: string;
  type: any;
}

export interface SchemaAvro {
  type: string;
  name: string;
  fields: Type[];
}

export const WidgetAvro = ({
  items,
  onChange,
  setItems,
  setIncorrectDefaultValue
}: {
  items: Type[];
  onChange: (value: TypeWithoutID[]) => void;
  setItems:(items:Type[]) => void,
  setIncorrectDefaultValue:(value:boolean) => void
}): FunctionComponentElement<NodeInputProps> => {

  // set item after is updated
  const setItem = (index: number, value: Type) => {
    const tmpItems = Array.from(items);
    tmpItems[index] = value;
    setItems(tmpItems);

    onChange(tmpItems.map((val) => ({name:val.name,type:val.type})));
  };

  // remove item by index
  const removeItem = (index: number) => {
    const tempItems = Array.from(items);
    tempItems.splice(index, 1);
    setItems(tempItems);
    onChange(tempItems.map((val) => ({name:val.name,type:val.type})));
  };

  // remove item by index
  const addItem = () => {
    const tempItems = Array.from(items);
    tempItems.push({ name: "", type: "", id: uuidv4() });
    setItems(tempItems);
    setIncorrectDefaultValue(false)
    onChange(tempItems.map((val) => ({name:val.name,type:val.type})));
  };

  // update item array when row is dropped
  const onDragEnd = (result: any) => {
    if (!result.destination) {
      return;
    }

    const reorderedItems = Array.from(items);

    const [removed] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, removed);

    setItems(reorderedItems);
    onChange(reorderedItems.map((val) => ({name:val.name,type:val.type})));
  };

  return (
    <div className="avro mt-5 mb-2">
      <div className="titles">
        <div className="row">Type</div>
        <div className="row "> Nom </div>
      </div>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="avro">
          {(provided: any) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {items.map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index}>
                  {(provided: any) => (
                    <div
                      className="avro"
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                    >
                      <div className="mt-2">
                        <Field
                          UpdateValue={(value) => {
                            setItem(index, {
                              id: item.id,
                              name: value.name,
                              type: value.type,
                            });
                          }}
                          type={item.type}
                          remove={() => removeItem(index)}
                          drag={provided.dragHandleProps}
                          name={item.name}
                        />
                        <div></div>
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      <div className="flex justify-content-center">
        <Button
          className=" mt-3 p-button-text"
          type="button"
          label="AJOUTER UNE COLONNE"
          onClick={() => addItem()}
          icon="pi pi-plus"
        />
      </div>
    </div>
  );
};
